import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * 主题 / 布局设置切片。
 *
 * 与 ProLayout 的 ProSettings 字段命名严格对齐，方便直接展开作为
 * ProLayout / SettingDrawer 的 settings prop。AntdProvider 同样从这里读
 * `navTheme` / `colorPrimary` 算出 ConfigProvider 主题。
 */
export type ThemeSettings = {
  /** 布局风格：side（侧栏）/ top（顶栏）/ mix（混合） */
  layout: 'side' | 'top' | 'mix';
  /** 整体配色：light / realDark */
  navTheme: 'light' | 'realDark';
  /** 主色 */
  colorPrimary: string;
  /** 内容宽度：Fluid 全宽 / Fixed 固定 */
  contentWidth: 'Fluid' | 'Fixed';
  /** 固定头部 */
  fixedHeader: boolean;
  /** 固定侧栏 */
  fixSiderbar: boolean;
  /** 多页签（本次不启用） */
  splitMenus: boolean;
};

type ThemeStore = ThemeSettings & {
  update: (patch: Partial<ThemeSettings>) => void;
  reset: () => void;
};

const DEFAULTS: ThemeSettings = {
  layout: 'mix',
  navTheme: 'light',
  colorPrimary: '#1677FF',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  splitMenus: false,
};

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      ...DEFAULTS,
      update: (patch) => set(patch),
      reset: () => set(DEFAULTS),
    }),
    { name: 'dispatch-theme' },
  ),
);
